// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getPro_lnglistListReducer } from './getPro_lnglistList';
import { reducer as submitPro_lnglistReducer } from './submitPro_lnglist';
import { reducer as deletePro_lnglistReducer } from './deletePro_lnglist';
import { reducer as pro_lnglistModalChangeReducer } from './pro_lnglistModalChange';
import { reducer as chooseCurrentPro_lnglistReducer } from './chooseCurrentPro_lnglist';
import { reducer as gongkaifabuActionsReducer } from './gongkaifabuActions';
import { reducer as dianziGenerateActionsReducer } from './dianziGenerateActions';
import { reducer as yJgeneratePassCardActionsReducer } from './yJgeneratePassCardActions';
import { reducer as productHgzGenerateActionsReducer } from './productHgzGenerateActions';
import { reducer as chooseCurrenProductModelReducer } from './chooseCurrenProductModel';
import { reducer as chooseCurrenFaBuModelReducer } from './chooseCurrenFaBuModel';
import { reducer as allMaintainActionsReducer } from './allMaintainActions';
import { reducer as chooseCurrenMaintainModelReducer } from './chooseCurrenMaintainModel';
import { reducer as chooseCurrenDeleteModelReducer } from './chooseCurrenDeleteModel';
import { reducer as deleteProAlllnglistReducer } from './deleteProAlllnglist';
import { reducer as setQuantityReducer } from './setQuantity';
import { reducer as submitProAlllnglistReducer } from './submitProAlllnglist';
import { reducer as chooseCurrenYjLabelReducer } from './chooseCurrenYjLabel';
import { reducer as yjlabelActionsReducer } from './yjlabelActions';
import { reducer as chooseCurrenProductModelCustomReducer } from './chooseCurrenProductModelCustom';
import { reducer as getProLnglistListAllReducer } from './getProLnglistListAll';
import { reducer as getProAssignFaMenReducer } from './getProAssignFaMen';
import { reducer as remarkModalChangeReducer } from './remarkModalChange';
import { reducer as mediumSafetyUploadingChooseReducer } from './mediumSafetyUploadingChoose';
import { reducer as qpdataFileUploadingChooseReducer } from './qpdataFileUploadingChoose';
import { reducer as mediumSafetyUploadingActionReducer } from './mediumSafetyUploadingAction';
import { reducer as qpDataFileUploadingActionReducer } from './qpDataFileUploadingAction';
import { reducer as qualityProveModalChangeReducer } from './qualityProveModalChange';
import { reducer as qualityProveCompileActionReducer } from './qualityProveCompileAction';
import { reducer as qpParamsFileUploadChooseReducer } from './qpParamsFileUploadChoose';
import { reducer as qpParamsFileUploadingActionReducer } from './qpParamsFileUploadingAction';

const reducers = [
  getPro_lnglistListReducer,
  submitPro_lnglistReducer,
  deletePro_lnglistReducer,
  pro_lnglistModalChangeReducer,
  chooseCurrentPro_lnglistReducer,
  gongkaifabuActionsReducer,
  dianziGenerateActionsReducer,
  yJgeneratePassCardActionsReducer,
  productHgzGenerateActionsReducer,
  chooseCurrenProductModelReducer,
  chooseCurrenFaBuModelReducer,
  allMaintainActionsReducer,
  chooseCurrenMaintainModelReducer,
  chooseCurrenDeleteModelReducer,
  deleteProAlllnglistReducer,
  setQuantityReducer,
  submitProAlllnglistReducer,
  chooseCurrenYjLabelReducer,
  yjlabelActionsReducer,
  chooseCurrenProductModelCustomReducer,
  getProLnglistListAllReducer,
  getProAssignFaMenReducer,
  remarkModalChangeReducer,
  mediumSafetyUploadingChooseReducer,
  qpdataFileUploadingChooseReducer,
  mediumSafetyUploadingActionReducer,
  qpDataFileUploadingActionReducer,
  qualityProveModalChangeReducer,
  qualityProveCompileActionReducer,
  qpParamsFileUploadChooseReducer,
  qpParamsFileUploadingActionReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/product/redux/reducer.js